"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectInput = exports.BaseTextArea = exports.NumberInput = exports.BaseInput = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importStar(require("styled-components"));
var react_number_format_1 = __importDefault(require("react-number-format"));
var reset = styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font: inherit;\n  line-height: 1;\n  color: inherit;\n  background: transparent;\n  outline: none;\n  border: none;\n  box-shadow: none;\n  padding: 0;\n  margin: 0;\n  width: 100%;\n  display: block;\n"], ["\n  font: inherit;\n  line-height: 1;\n  color: inherit;\n  background: transparent;\n  outline: none;\n  border: none;\n  box-shadow: none;\n  padding: 0;\n  margin: 0;\n  width: 100%;\n  display: block;\n"])));
/**
 * Input
 */
exports.BaseInput = styled_components_1.default.input(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  flex: 1;\n\n  /* Remove spinner from number input (Chrome desktop, Safair desktop) */\n  &[type=\"number\"]::-webkit-inner-spin-button,\n  &[type=\"number\"]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n  }\n\n  /* Remove date picker from date input (Chrome desktop) */\n  &::-webkit-calendar-picker-indicator {\n    display: none;\n  }\n"], ["\n  ", "\n  flex: 1;\n\n  /* Remove spinner from number input (Chrome desktop, Safair desktop) */\n  &[type=\"number\"]::-webkit-inner-spin-button,\n  &[type=\"number\"]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n  }\n\n  /* Remove date picker from date input (Chrome desktop) */\n  &::-webkit-calendar-picker-indicator {\n    display: none;\n  }\n"])), reset);
var numberInputProps = {
    integer: {
        thousandSeparator: true,
        thousandsGroupStyle: "thousand",
        allowNegative: false,
        allowLeadingZeros: false,
    },
    decimal: {
        thousandSeparator: true,
        thousandsGroupStyle: "thousand",
        allowNegative: false,
        fixedDecimalScale: true,
        allowLeadingZeros: false,
    },
    percent: {
        suffix: "%",
        allowNegative: false,
        isAllowed: function (_a) {
            var floatValue = _a.floatValue;
            return !(typeof floatValue === "number" && floatValue > 100);
        },
    },
    currency: {
        prefix: "USD ",
        thousandSeparator: true,
        thousandsGroupStyle: "thousand",
        allowNegative: false,
        fixedDecimalScale: true,
        allowLeadingZeros: false,
    },
};
function BaseNumberInput(props) {
    var value = props.value, onChange = props.onChange, type = props.type, rest = __rest(props, ["value", "onChange", "type"]);
    var numberFormatProps = numberInputProps[type];
    return (jsx_runtime_1.jsx(react_number_format_1.default, __assign({}, rest, numberFormatProps, { value: value, isNumericString: true, onValueChange: function (_a) {
            var value = _a.value;
            return onChange && onChange(value);
        } }), void 0));
}
exports.NumberInput = styled_components_1.default(BaseNumberInput)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  flex: 1;\n"], ["\n  ", "\n  flex: 1;\n"])), reset);
/**
 * TextArea
 */
exports.BaseTextArea = styled_components_1.default.textarea(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n  flex: 1;\n  resize: vertical;\n"], ["\n  ", "\n  flex: 1;\n  resize: vertical;\n"])), reset);
/**
 * Select
 */
var BaseSelect = styled_components_1.default.select(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n  flex: 1;\n  -webkit-appearance: none;\n"], ["\n  ", "\n  flex: 1;\n  -webkit-appearance: none;\n"])), reset);
var BaseOption = styled_components_1.default.option(templateObject_6 || (templateObject_6 = __makeTemplateObject([""], [""])));
function SelectInput(props) {
    return (jsx_runtime_1.jsx(BaseSelect, __assign({ value: props.value, onChange: function (event) {
            return props.onChange && props.onChange(event.target.value, event);
        }, disabled: props.disabled }, { children: (props.options || []).map(function (option) { return (jsx_runtime_1.jsx(BaseOption, __assign({ value: option.id }, { children: option.name }), option.id)); }) }), void 0));
}
exports.SelectInput = SelectInput;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=input.js.map